// ANCHOR Styletron
import { StyleObject } from 'styletron-react';

// ANCHOR THEME
import { THEME } from '@lyon/utils/theme';

export enum BadgeColor {
  // ANCHOR Standard
  default = 'default',
  primary = 'primary',
  negative = 'negative',
  positive = 'positive',
  accent = 'accent',
  // ANCHOR Inverse
  inverseDefault = 'inverseDefault',
  inversePrimary = 'inversePrimary',
  inverseNegative = 'inverseNegative',
  inversePositive = 'inversePositive',
  inverseAccent = 'inverseAccent',
  // ANCHOR Common
  black = 'black',
  white = 'white',
}

interface IProps {
  color: BadgeColor;
}

const status = {
  // ANCHOR Standard
  default: THEME.colors.primaryA,
  primary: THEME.colors.primary,
  negative: THEME.colors.negative400,
  positive: THEME.colors.positive450,
  accent: THEME.colors.accent,
  // ANCHOR Inverse
  inverseDefault: THEME.colors.darkmuted500,
  inversePrimary: THEME.colors.white,
  inverseNegative: THEME.colors.white,
  inversePositive: THEME.colors.darkmuted500,
  inverseAccent: THEME.colors.darkmuted500,
  // ANCHOR Common
  black: THEME.colors.black,
  white: THEME.colors.white,
};

const statusBackground = {
  // ANCHOR Standard
  default: THEME.colors.darkmuted500,
  primary: THEME.colors.darkmuted500,
  negative: THEME.colors.darkmuted500,
  positive: THEME.colors.darkmuted500,
  accent: THEME.colors.darkmuted500,
  // ANCHOR Inverse
  inverseDefault: THEME.colors.primaryA,
  inversePrimary: THEME.colors.primary,
  inverseNegative: THEME.colors.negative400,
  inversePositive: THEME.colors.positive450,
  inverseAccent: THEME.colors.accent,
  // ANCHOR Common
  black: THEME.colors.mono400,
  white: THEME.colors.darkmuted500,
};

// ANCHOR Badge Style
export const BADGE = ({ color = BadgeColor.default }: IProps): StyleObject => ({
  color: status[color],
  fontSize: '12px',
  paddingLeft: '8px',
  paddingRight: '8px',
  paddingTop: '4px',
  paddingBottom: '4px',
  fontFamily: 'IBM Plex Sans',
  fontWeight: 600,
  width: 'max-content',
  backgroundColor: statusBackground[color],
});
